import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';
import type { MouseEvent, ReactNode } from 'react';

export type BackLinkProps = LinkProps & { readonly children: ReactNode };

const isPlainClick = (event: MouseEvent) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

/**
 * "← Clients" link above profile headers (design: 28px, 0 8px, -8px margin, 13px/500 fg-2). Works
 * like the browser's back button: it returns to the previous screen of the app (a project the
 * client was opened from), and goes to `to` only when there is no history (a fresh tab).
 */
export function BackLink({ children, ...link }: BackLinkProps) {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!canGoBack || !isPlainClick(event)) return;
    event.preventDefault();
    router.history.back();
  };
  return (
    <Link
      {...link}
      onClick={onClick}
      className="-ml-2 inline-flex h-7 items-center rounded-lg px-2 text-[13px] font-medium text-fg-2 no-underline hover:bg-neutral-100 hover:text-fg-2"
    >
      ← {children}
    </Link>
  );
}
